module.exports = __webpack_public_path__ + "assets/img/HotTicket_tit.f848e746.png";